
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "../../common/common-interface";
import { sysLogin } from "@/api/api-basic";
import sha256 from "js-sha256";
import { State, Mutation } from "vuex-class";
import { getMerchantInfo } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
@Component
export default class PiLogin extends Vue {
  @State("sys") sys!: objAny;
  @Mutation("SET_ISLOGIN") SET_ISLOGIN!: Function;
  private test = "light";
  private loading = false;
  private title = process.env.VUE_APP_TITLE;
  private logoPageInfo: objAny = {
    // loginPageSlogan: "为 美 好 生 活 充 电",
    fullName: ""
  };
  private changeLangList: objAny[] = [
    {
      value: process.env.VUE_APP_LANG,
      label: process.env.VUE_APP_LANG_NAME
    },
    {
      value: "en-US",
      label: "English"
    }
  ];

  private formInline: objAny = {
    userName: "",
    password: "",
    loginType: "0",
    subSystemPkId: "3",
    verCode: "",
    changeLang: ""
  };
  private ruleInline: objAny = {
    userName: [
      {
        required: true,
        message: i18n.t("login.userNamePl"),
        trigger: "blur"
      }
    ],
    password: [
      {
        required: true,
        message: i18n.t("login.passwordPl"),
        trigger: "blur"
      },
      {
        type: "string",
        min: 6,
        message: i18n.t("login.passwordMax"),
        trigger: "blur"
      }
    ]
  };

  public changeLangFn(val: string): void {
    this.$i18n.locale = val;
    localStorage.setItem("language", val);
    this.ruleInline.userName[0].message = i18n.t("login.userNamePl");
    this.ruleInline.password[0].message = i18n.t("login.passwordPl");
    this.ruleInline.password[1].message = i18n.t("login.passwordMax");
  }
  public handleSubmit(): void {
    const eleSub: objAny = this.$refs["formInline"];
    eleSub.validate((valid: objAny) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  public submitData2(): void {
    this["$common"].save("loginData", this.formInline);
    this["$router"].push("/");
  }
  async submitData(): Promise<void> {
    const json: objAny = JSON.parse(JSON.stringify(this.formInline));
    json.password = sha256.sha256(json.password);
    this.loading = true;
    const ret = await sysLogin(json);
    if (ret.status == this["$config"].apiStatus) {
      this["$common"].save("loginData", ret.data[0]);
      this["$router"].push("/");
      if (
        ret.data[0].expireRemindDate != null &&
        ret.data[0].expireRemindDate >= 0
      ) {
        this["$Notice"].warning({
          title: i18n.t("tips") + "",
          desc:
            i18n.t("login.accountTime") +
            ret.data[0].expireRemindDate +
            i18n.t("login.accountTime2"),
          duration: 15
        });
      }
    }
    this.loading = false;
  }
  async getMerchantInfo(merchantPkId: string) {
    const ret = await getMerchantInfo({
      merchantPkId: merchantPkId
    });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      this.logoPageInfo.title = data.fullName;
    }
  }
  mounted() {
    if (process.env.VUE_APP_SHOWCHINESE === "1") {
      this.changeLangList.push({
        value: "zh-CN",
        label: "简体中文"
      });
    }
    if (!localStorage.language) {
      this.$i18n.locale = process.env.VUE_APP_LANG;
      this.formInline.changeLang = process.env.VUE_APP_LANG;
      this.changeLangFn(process.env.VUE_APP_LANG);
    } else {
      this.formInline.changeLang = localStorage.language;
    }

    if (this.sys.isLogin) {
      this.SET_ISLOGIN(false);
      this["$common"].out();
    }
    document.onkeydown = event => {
      if (event.keyCode === 13 && !this.loading) {
        this.handleSubmit();
        return false;
      }
    };
    if (this.$route.query.merchantPkId) {
      const query: objAny = this.$route.query;
      // this.getMerchantInfo(query.merchantPkId);
    }
  }
  destroyed() {
    document.onkeydown = null;
  }
}
